import { Fragment } from 'react';

import { styled } from '@project44/manifest-ds';

import * as icons from './icons';
import PlusIcon from './icons/plusIcon';

const Key = styled('span', {
  display: 'inline-block',
  height: '28px',
  minWidth: '28px',
  margin: '4px',
  padding: '0 8px',
  background: '#2A343F',
  borderRadius: '2px',
  fontWeight: '600',
  lineHeight: '28px',
  fontSize: '16px',
  textAlign: 'center',
  ' > svg': {
    width: '16px',
    height: '16px',
    position: 'relative',
    top: '3px',
  },
});

const KEY_ICONS: Record<string, () => JSX.Element> = {
  ARROW_LEFT: icons.arrowLeft,
  ARROW_RIGHT: icons.arrowRight,
};

const SingleKeyPressIcon = ({ name }: { name: string }) => {
  if (KEY_ICONS[name]) {
    const KeyIcon = KEY_ICONS[name];
    return (
      <Key>
        <KeyIcon />
      </Key>
    );
  }
  return <Key>{name}</Key>;
};

export const KeyPressIcon = ({ name }: { name: string | string[] }) => {
  if (Array.isArray(name)) {
    return (
      <Fragment>
        {name.map((k, i) => (
          <Fragment key={`fragment-${i}`}>
            <SingleKeyPressIcon key={`key-${i}`} name={k} />
            {i !== name.length - 1 && <PlusIcon key={`plus-${i}`} />}
          </Fragment>
        ))}
      </Fragment>
    );
  }

  return <SingleKeyPressIcon name={name} />;
};
